import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { FormProvider, useForm } from "react-hook-form";
import StepperIncluirLancamento from "./Stepper";
import { formatarMonetárioParaNúmero } from "../../../../../helpers/masks";
import { useMutation } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';

export default function DialogIncluirLancamento({
    open,
    handleClose
}: DialogIncluirLancamentoProps) {

    //Querys e mutations
    const { mutate: solicitarCriacaoLancamento } = useMutation({
        mutationKey: 'solicitar-criacao-titulo',
        mutationFn: (inputs: any) => axiosClient.post("/financeiro/conta-corrente-consumo/cadastrar-lancamento", inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao cadastrar lançamento!', { variant: 'error' });
        },
        onSuccess: ({ data }) => {
            enqueueSnackbar(`Lançamento criado com sucesso!`, { variant: 'success' });
            handleLimparSteps()
        },
        onSettled: () => setValue('isLoadingIncluirLancamento', false)
    })

    const handleNextStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper + 1)
    }

    const handleBackStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper - 1)
    }

    const handleLimparSteps = () => {   
        setValue('step02', defaultValuesForm.step02)
        setValue('step03', defaultValuesForm.step03)
        setValue('stepper', 1)
    }

    const onSubmit = (data: any) => {
        setValue('isLoadingIncluirLancamento', true)
        const params = {
            //STEP01
            conta_devedora_codigo: data.step01.conta_contabil.codigo_contabil,
            conta_devedora_custo: data.step01.conta_contabil.centro_custo,
            data_lancamento: moment(data.step01.data_lancamentos).format("YYYY-MM-DD"),
            //Contem a fonte_CS e custo_cs
            tipo_lancamento_id: data.step01.tipo_lancamento.id,
            dc_cs: data.step01.debito_credito === 'D' ? 'B' : 'C',
            operacao_id: data.step01.operacao.id,

            //STEP02
            tipo_publico: data.step02.publico.tipo_publico,
            codigo_publico: data.step02.publico.codigo_publico,
            fazenda_id: data.step02.fazenda.apelido,
            loja_id: data.step02.loja.id,
            valor_lancamento: formatarMonetárioParaNúmero(data.step02.valor),
            numero_documento: data.step02.nr_documento,
            serie_documento: data.step02.serie_documento,
            comprador: data.step02.comprador,
            historico: data.step02.historico,
            lote: data.step02.lote,

            //STEP03 - RATEIO
            ...(data.step03.add_rateio === "true" && {
                rateios: data.step03.rateios.map((rateio: any) => ({
                    conta_devedora_codigo: rateio.contaDevedora.codigo_contabil,
                    conta_devedora_custo: rateio.contaDevedora?.centro_custo?.id || null,
                    valor: formatarMonetárioParaNúmero(rateio.valor)
                }))
            }),
        }
        solicitarCriacaoLancamento(params)
    }

    const defaultValuesForm = {
        isLoadingIncluirLancamento: false,
        stepper: 0,
        step01: {
            conta_contabil: '',
            data_lancamentos: null,
            tipo_lancamento: '',
            debito_credito: '',
            operacao: '',
            credito_label: '',
            debito_label: '',
        },
        step02: {
            publico: '',
            fazenda: '',
            loja: '',
            valor: '',
            nr_documento: '',
            serie_documento: '',
            comprador: '',
            historico: '',
            lote: ''
        },
        step03: {
            add_rateio: 'false',
            rateios: []
        },
        funcoesAux: {
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose,
            onSubmit: onSubmit
        },
    }

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue, } = methods

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth={'md'}
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Criar lançamento</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <StepperIncluirLancamento />
                </DialogContent>
            </Dialog>
        </FormProvider>
    )
}

export interface DialogIncluirLancamentoProps {
    open: boolean;
    handleClose: () => void
}
